export const humanizeCamelCase = (value) =>
  value
    ? value
        .replace(/([A-Z])/g, ' $1')
        .replace(/^\w/, (char) => char.toUpperCase())
    : '';
